/**
 * @module string-utils
 * @name format
 * @kind function
 *
 * @param {*=} params Parameters
 *
 * @return {function(string)}
 *
 * @description
 * Do the same thing as [JAVA MessageFormat.format](https://docs.oracle.com/javase/7/docs/api/java/text/MessageFormat.html#format(java.lang.String,%20java.lang.Object...))
 *
 * @example
 * ```js
 *      format("world")("Hello {1}"); // "Hello world"
 * ```
 */
export function format(...params: string[]) {
    return (text: string) => {
        if (text === undefined || text === null) {
            throw new TypeError('`text` must be defined');
        }

        let str = String(text);
        let i = params.length;

        while (i--) {
            str = str.replace(new RegExp(`\\{${i}\\}`, 'gm'), params[i]);
        }

        return str;
    }
}

/**
 * @module string-utils
 * @name strToBool
 * @kind function
 *
 * @param {string} str Converted value
 *
 * @returns {boolean}
 *
 * @description
 * Converts string to boolean.
 */
export function strToBool(str: string): boolean {
    if (typeof str !== 'string') {
        throw new TypeError(`Cannot convert ${typeof str} to boolean.`);
    }

    return str.toLocaleLowerCase() === 'true';
}
